import styled from "styled-components";

export const Label = styled.label`
  font-size: 1.5rem;
  font-weight: bold;
  margin-bottom: 2.5rem;
  color: var(--accent);
`
